import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../button'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'
import Card from './index'
import Icon from '../icon'
import DownloadFullColorIcon from '../icon/download-full-color.svg'

import AccessTime from '../../bantrab/icon/access_time.svg'

import ArrowRight from '../../bantrab/icon/arrow-right.svg'
import Calendar from '../icon/calendar.svg'

const WebinarMediun = ({ teacher, title, category, textContent, publica, view, read, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {

    [styles.recursoMediun]: true,
    [styles.card]: true
  })

  return (
    <div {...attrs}>
      <Card.Media
        solid
        className={'bg-green-500 flex-col w-full'}
        background={'black'}

        widgetRight={
          <Typography
            type={'bold'}
            size={'three'}
            className={'flex  items-center justify-center w-full  h-56'}>
            <Icon
              width='56'
              height='56'
              svg={DownloadFullColorIcon}
            />
          </Typography>
        }
      />
      <Card.Body>

        <div className="ml-4 mr-16  mt-4 ">
          <Typography
            type={'bold'}
            size={'four'}
            className={'text-$black '}
          >
            {title}
          </Typography>
          <Typography
            type={'regular'}
            size={'three'}
            className={' mt-3 text-$black '}
          >
            {teacher}
          </Typography>

          <div
            className={'flex mb-4 flex-row  items-center mt-3'}
          >
            <Typography
              type={'regular'}
              size={'two'}
              className={' w-full mr-8 text-$black-80 items-center '}
            >
              <Icon
                className={'mr-2.5 '}
                size={20}
                svg={Calendar}
              />
              {publica}
            </Typography>
            <Typography
              size={'two'}
              className={'w-90 text-gray-400 '}>
              <Icon
                className={'mr-2.5'}
                size={20}
                svg={AccessTime}
              />
              {view}
            </Typography>
          </div>
        </div>
        <Button
          className={'w-full'}
          arrow
          background
          href="https://www.google.com"
          iconRight
          target="_blank"

        >
          Unete ahora
          <Icon className={'ml-2'} size={24} svg={ArrowRight} />
        </Button>
      </Card.Body>

    </div>
  )
}

WebinarMediun.propTypes = {
  teacher: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  publica: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  view: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  read: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])

}

export default WebinarMediun
